var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c("h2", [_vm._v("My Events:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "event-container" },
        [
          _vm._l(_vm.events, function(event) {
            return _c(
              "router-link",
              { key: event.id, attrs: { to: "/event/" + event.id } },
              [
                _c("div", { staticClass: "event-card" }, [
                  _c("h4", [_vm._v(_vm._s(event.name))])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("router-link", { attrs: { to: "/eventcreate" } }, [
            _c("div", { staticClass: "event-card" }, [
              _c("h4", [_vm._v("Create Event")])
            ])
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-header" }, [
      _c("div", { staticClass: "header-upper" }, [
        _c("h2", [_vm._v("COMPENDIUM")]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-btn" }, [
          _c("i", { staticClass: "fas fa-user-circle" }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-chevron-down" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-lower" }, [
        _c("span", [_vm._v("My Team")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52077837", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52077837","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/index.vue
// module id = qQYN
// module chunks = 1